import { render } from "./Pedido.vue?vue&type=template&id=7c2b5464&scoped=true"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"

import "./Pedido.vue?vue&type=style&index=0&id=7c2b5464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2b5464"]])

export default __exports__